import { render, staticRenderFns } from "./ElacMessagePopup.vue?vue&type=template&id=31ee3f53"
import script from "./ElacMessagePopup.vue?vue&type=script&lang=js"
export * from "./ElacMessagePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports